import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { PasswordSuccessfulComponent } from '../password-successful/password-successful.component';
import { RedirectService } from "../redirect/redirect.service";
import { changePasswordService } from "./change-password.service";

declare var $: any;

@Component({
    selector: "app-change-password",
    templateUrl: "./change-password.component.html",
    styleUrls: ["./change-password.component.scss"]
})
export class ChangePasswordComponent implements OnInit {
    public modalOpen: boolean;
    changePasswordForm: FormGroup;
    errMessage: String;
    user: any = {};
    errorexistingpassword : boolean = false;
    errorconfirmpassword : boolean = false;
    message: String;
    displayPwd: Boolean;
    displayPwd1: Boolean;


    constructor(
        private _changePasswordService: changePasswordService,
        private _router: Router,
        private _redirectService: RedirectService,
        private _activatedRoute: ActivatedRoute,
        public activeModal: NgbActiveModal,
        private modalService: NgbModal,
        private _formBuilder: FormBuilder
    ) {}

    ngOnInit() {
        console.log("helo world");

        this._changePasswordService.modal.subscribe(isOpen => {
            console.log("i received to open modal ?", isOpen);
            this.modalOpen = isOpen as boolean;
        });

        this.changePasswordForm = this._formBuilder.group({
            existingpassword: [
                "",
                [Validators.required]
            ],
            confirmpassword: [
                "",
                [Validators.required, Validators.minLength(8)]
            ]
        });
    }

    submitted = false;

    ConfirmChangePassword() {
        this.errorexistingpassword = false;
        this.errorconfirmpassword = false;

        this.submitted = true;
        this.message = '';
        this.errMessage = "";
        console.log("hello wrld");
        const obj = {
            oldPassword: this.changePasswordForm.value.existingpassword,
            newPassword: this.changePasswordForm.value.confirmpassword
        };

 if (this.changePasswordForm.value.existingpassword === '') {
                this.errorexistingpassword = true;
                return;

            }else {
                this.errorexistingpassword = false;
            }

            if (this.changePasswordForm.value.confirmpassword === '') {
                this.errorconfirmpassword = true;
                return;

            }else {
                this.errorconfirmpassword = false;
            }
        if (this.changePasswordForm.valid) {
            this.errMessage = "";
            this.user.password = this.changePasswordForm.value.password;
console.log(this.changePasswordForm.value.password);
            if(this.changePasswordForm.value.existingpassword === this.changePasswordForm.value.confirmpassword) {
                this.message ="Current & New password should be different";
                return;
            }
            this._changePasswordService.changePassword(obj).subscribe(
                (result: any) => {
                    console.log(result);
                    this.errMessage = "";
                    this.closeModal();
                    this.openSuccessModal();
                },
                err => {
                    console.error(err);
                    this.errMessage = err.error.message;
                }
            );
        }
    }

    closeModal() {
        this._changePasswordService.close();
        this.activeModal.dismiss();
    }
        openSuccessModal=()=> {
        const modalRef = this.modalService.open(PasswordSuccessfulComponent);

    }
    togglePasswordFieldDisplay() {
        this.displayPwd = !this.displayPwd;
        if ($('#existingpassword').get(0).type === 'password') {
            $('#existingpassword').prop('type', 'text');
        } else {
            $('#existingpassword').prop('type', 'password');
        }
    }


    toggleChangePasswordFieldDisplay() {
        this.displayPwd1 = !this.displayPwd1;
        if ($('#confirmpassword').get(0).type === 'password') {
            $('#confirmpassword').prop('type', 'text');
        } else {
            $('#confirmpassword').prop('type', 'password');
        }
    }


resetError(){
    this.errorexistingpassword = false;
    this.errorconfirmpassword = false;
}
}



// WEBPACK FOOTER //
// ./src/app/change-password/change-password.component.ts